module.exports = __webpack_public_path__ + "static/media/unclockCal.927630f1.svg";